import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/pro-solid-svg-icons';

import AddControl from 'components/add_control';

import './styles.scss';

export default function FieldsCollection({
  addLabel = 'Add',
  children,
  full,

  // Only relevant when there is only one child, to hide the remove control
  hasValue,

  onAdd,

  // Called when "removing" the final child
  // Using onRemoveIndex instead would cause flickering by the effect hook
  onClear,

  onRemoveIndex,
}) {
  React.useEffect(() => {
    if (children.length === 0) {
      onAdd();
    }
  }, [children]);

  return <React.Fragment>
    {React.Children.map(children, (child, i) => (
      <div className="deal-fields-collection-item" key={i} name="child">
        {child}

        <FontAwesomeIcon
          className={classNames('clickable', 'mb-3', 'ml-3', {
            invisible: child.props.removable === false || (!hasValue && children.length === 1)
          })}
          icon={faTrashAlt}
          name="remove"
          onClick={() => children.length === 1 ? onClear() : onRemoveIndex(i)}
        />
      </div>
    ))}

    {!full && <AddControl onClick={onAdd}>{addLabel}</AddControl>}
  </React.Fragment>;
}

FieldsCollection.propTypes = {
  addLabel: PropTypes.string,
  children: PropTypes.node.isRequired,
  full: PropTypes.bool,
  hasValue: PropTypes.bool,
  onAdd: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  onRemoveIndex: PropTypes.func.isRequired,
};
